
export const ruCommon = {
  // Navigation
  'nav.home': 'Главная',
  'nav.about': 'О нас',
  'nav.services': 'Услуги',
  'nav.products': 'Продукты',
  'nav.projects': 'Проекты',
  'nav.partners': 'Партнеры',
  'nav.news': 'Новости',
  'nav.contact': 'Контакты',
  
  // Common buttons
  'btn.readMore': 'Читать далее',
  'btn.contact': 'Связаться с нами',
  'btn.consultation': 'Бесплатная консультация',
  'btn.viewProjects': 'Посмотреть проекты',
  'btn.learnMore': 'Узнать больше',
  'btn.callUs': 'Позвонить нам',
  'btn.requestConsultation': 'Запросить консультацию',
  'btn.viewDetails': 'Посмотреть детали',
  'btn.buy': 'Купить',
  'btn.subscribe': 'Подписаться',
  'btn.viewAll': 'Посмотреть все',
  'btn.getQuote': 'Получить предложение',
  'btn.viewCatalog': 'Посмотреть полный каталог',
  'btn.contactExperts': 'Связаться с экспертами',
  
  // Common phrases
  'common.years': 'лет',
  'common.experience': 'опыт',
  'common.projects': 'проекты',
  'common.customers': 'клиенты',
  'common.readTime': 'мин чтения',
  'common.location': 'Местоположение',
  'common.area': 'Площадь',
  'common.established': 'Основана',
  'common.employees': 'сотрудники',
  'common.specialization': 'Специализация',
  'common.category': 'Категория',
  'common.tags': 'Теги',
  'common.date': 'Дата',
  'common.search': 'Поиск',
  'common.filter': 'Фильтр',
  'common.all': 'Все',
  'common.new': 'Новое',
  'common.found': 'найдено',
  'common.searchPlaceholder': 'Поиск продуктов...',
  
  // Company info
  'company.name': 'Iran GH',
  'company.tagline': 'Умные теплицы',
  'company.description': 'Проектировщик, строитель и поставщик оборудования умных стеклянных теплиц в Иране',
  'company.phone': '021-88441386',
  'company.email': 'info@irangh.com',
  'company.address': 'Тегеран, Иран',
  'company.salesManager': '0912-909-5302',
  
  // Footer
  'footer.quickLinks': 'Быстрые ссылки',
  'footer.services': 'Наши услуги',
  'footer.contactInfo': 'Контактная информация',
  'footer.copyright': '© 2024 Iran GH. Все права защищены.',
  'footer.privacy': 'Политика конфиденциальности',
  'footer.terms': 'Условия использования',
  'footer.madeWith': 'Made with Readdy',
  
  // News page
  'news.title': 'Последние новости и информация',
  'news.subtitle': 'Будьте в курсе последних разработок в области тепличных технологий',
  'news.heroTitle': 'Последние новости и информация',
  'news.heroSubtitle': 'Последние новости, технологии и инновации в мире теплиц и современного сельского хозяйства',
  'news.featured': 'Рекомендуемые новости',
  'news.recent': 'Другие новости',
  'news.categories': 'Категории',
  'news.searchPlaceholder': 'Поиск в новостях, статьях и тегах...',
  'news.project': 'Проект',
  'news.technology': 'Технология',
  'news.product': 'Продукты',
  'news.international': 'Международные',
  'news.tips': 'Технические советы',
  'news.research': 'Исследования',
  'news.events': 'События',
  'news.all': 'Все',
  'news.readMore': 'Читать далее',
  'news.readTime': 'мин',
  'news.date': 'Дата',
  'news.category': 'Категория',
  'news.tags': 'Теги',
  'news.noResults': 'Результаты не найдены',
  'news.noResultsDesc': 'Пожалуйста, попробуйте другие ключевые слова',
  'news.articlesFound': 'статей найдено',
  'news.newsletter': 'Подписка на рассылку',
  'news.newsletterTitle': 'Подписка на рассылку',
  'news.newsletterDesc': 'Получайте последние новости и специализированные статьи о тепличных технологиях прямо на вашу электронную почту',
  'news.emailPlaceholder': 'Ваш адрес электронной почты',
  'news.subscribe': 'Подписаться',
  
  // News categories
  'news.cat.all': 'Все',
  'news.cat.project': 'Проект',
  'news.cat.products': 'Продукты',
  'news.cat.technology': 'Технологии',
  'news.cat.international': 'Международные',
  'news.cat.tips': 'Технические советы',
  'news.cat.research': 'Исследования',
  'news.cat.events': 'События',
  
  // Contact page
  'contact.title': 'Свяжитесь с нами',
  'contact.subtitle': 'Свяжитесь с экспертами Iran GH и получите бесплатную консультацию',
  'contact.phone': 'Телефонная связь',
  'contact.phoneDesc': 'Позвоните нам для немедленной консультации',
  'contact.email': 'Электронная почта',
  'contact.emailDesc': 'Отправьте нам ваши сообщения',
  'contact.address': 'Адрес офиса',
  'contact.addressDesc': 'Посетите нас по адресу ниже для личных встреч',
  'contact.fullAddress': 'Тегеран, улица Валиаср, дом 123, 5-й этаж',
  'contact.formTitle': 'Форма обратной связи',
  'contact.formDesc': 'Заполните форму ниже, чтобы наши эксперты могли связаться с вами как можно скорее',
  'contact.name': 'Полное имя',
  'contact.namePlaceholder': 'Введите ваше полное имя',
  'contact.email': 'Электронная почта',
  'contact.emailPlaceholder': 'Введите ваш адрес электронной почты',
  'contact.phoneNumber': 'Номер телефона',
  'contact.phonePlaceholder': 'Введите ваш номер телефона',
  'contact.projectType': 'Тип проекта',
  'contact.selectProjectType': 'Выберите тип проекта',
  'contact.commercial': 'Коммерческий',
  'contact.research': 'Исследовательский',
  'contact.hydroponic': 'Гидропонный',
  'contact.traditional': 'Традиционный',
  'contact.consultation': 'Консультация',
  'contact.budget': 'Примерный бюджет',
  'contact.selectBudget': 'Выберите примерный бюджет',
  'contact.under100k': 'Менее $100,000',
  'contact.budget100k500k': '$100,000 - $500,000',
  'contact.budget500k1m': '$500,000 - $1,000,000',
  'contact.over1m': 'Более $1,000,000',
  'contact.timeline': 'Временные рамки проекта',
  'contact.selectTimeline': 'Выберите желаемые временные рамки',
  'contact.immediate': 'Немедленно',
  'contact.timeline1to3': '1-3 месяца',
  'contact.timeline3to6': '3-6 месяцев',
  'contact.timeline6plus': 'Более 6 месяцев',
  'contact.subject': 'Тема',
  'contact.subjectPlaceholder': 'Введите тему вашего сообщения',
  'contact.message': 'Сообщение',
  'contact.messagePlaceholder': 'Напишите полные детали вашего проекта и требований...',
  'contact.characters': 'символов',
  'contact.sendMessage': 'Отправить сообщение',
  'contact.sending': 'Отправка...',
  'contact.successMessage': 'Ваше сообщение успешно отправлено. Наши эксперты свяжутся с вами как можно скорее.',
  'contact.errorMessage': 'Ошибка отправки сообщения. Пожалуйста, попробуйте еще раз.',
  'contact.location': 'Местоположение',
  'contact.officeHours': 'Часы работы',
  'contact.saturday': 'Суббота',
  'contact.saturdayHours': '8:00 - 17:00',
  'contact.sunday': 'Воскресенье',
  'contact.sundayHours': '8:00 - 17:00',
  'contact.monday': 'Понедельник',
  'contact.mondayHours': '8:00 - 17:00',
  'contact.tuesday': 'Вторник',
  'contact.tuesdayHours': '8:00 - 17:00',
  'contact.wednesday': 'Среда',
  'contact.wednesdayHours': '8:00 - 17:00',
  'contact.thursday': 'Четверг',
  'contact.thursdayHours': '8:00 - 17:00',
  'contact.friday': 'Пятница',
  'contact.fridayHours': 'Закрыто',
  'contact.emergencySupport': 'Экстренная поддержка',
  'contact.emergencySupportDesc': 'Для срочных проблем с теплицами вне рабочих часов',
  'contact.faq': 'Часто задаваемые вопросы',
  'contact.faqDesc': 'Ответы на распространенные вопросы о контактах и услугах',
  'contact.faq.q1': 'Как я могу получить бесплатную консультацию?',
  'contact.faq.a1': 'Вы можете запросить бесплатную консультацию по телефону, электронной почте или заполнив форму обратной связи. Наши эксперты свяжутся с вами как можно скорее.',
  'contact.faq.q2': 'Каково время ответа на сообщения?',
  'contact.faq.a2': 'Обычно мы отвечаем на ваши сообщения в течение 24 часов. Для срочных вопросов лучше позвонить по телефону.',
  'contact.faq.q3': 'Возможно ли посещение места проекта?',
  'contact.faq.a3': 'Да, наши эксперты посещают место проекта для более детальной оценки и специализированной консультации.',
  'contact.faq.q4': 'Какова стоимость консультации и посещения объекта?',
  'contact.faq.a4': 'Первоначальная консультация и посещение объекта для серьезных проектов полностью бесплатны. Только в случае, если сотрудничество не продолжается, взимается плата за посещение объекта.',
  'contact.faq.q5': 'У вас есть круглосуточная поддержка?',
  'contact.faq.a5': 'Мы предоставляем круглосуточную поддержку для текущих клиентов и экстренных проблем с теплицами. По другим вопросам мы отвечаем в рабочие часы.',
  
  // UV Thread Product Page
  'product.uvThread.title': 'Нить UV для теплиц',
  'product.uvThread.subtitle': 'Профессиональная нить для подвязки растений в теплицах',
  'product.uvThread.description': 'Высококачественная нить UV для теплиц производства Iran GH, изготовленная из полипропилена с защитой от ультрафиолета. Идеально подходит для подвязки томатов, огурцов, бобовых и перца в тепличных условиях.',
  'product.uvThread.specifications': 'Технические характеристики',
  'product.uvThread.length': 'Длина',
  'product.uvThread.lengthValue': '2000 метров',
  'product.uvThread.weight': 'Вес',
  'product.uvThread.weightValue': '2 кг',
  'product.uvThread.color': 'Цвет',
  'product.uvThread.colorValue': 'Белый/Зеленый',
  'product.uvThread.manufacturer': 'Производитель',
  'product.uvThread.manufacturerValue': 'Iran GH',
  'product.uvThread.uvProtection': 'UV защита',
  'product.uvThread.uvProtectionValue': '4%',
  'product.uvThread.threadType': 'Тип нити',
  'product.uvThread.threadTypeValue': 'Крученая нить',
  'product.uvThread.material': 'Материал',
  'product.uvThread.materialValue': 'PP (Полипропилен)',
  'product.uvThread.tensileStrength': 'Прочность на разрыв',
  'product.uvThread.tensileStrengthValue': '15 кг',
  'product.uvThread.features': 'Особенности',
  'product.uvThread.feature1': 'Устойчивость к ультрафиолету',
  'product.uvThread.feature1Desc': 'Специальная защита от UV лучей предотвращает разрушение нити',
  'product.uvThread.feature2': 'Высокая прочность',
  'product.uvThread.feature2Desc': 'Выдерживает вес до 15 кг без разрыва',
  'product.uvThread.feature3': 'Простота установки',
  'product.uvThread.feature3Desc': 'Легко завязывается и не скользит',
  'product.uvThread.feature4': 'Долговечность',
  'product.uvThread.feature4Desc': 'Длительный срок службы в тепличных условиях',
  'product.uvThread.applications': 'Применение',
  'product.uvThread.app1': 'Томаты',
  'product.uvThread.app1Desc': 'Подвязка стеблей и кистей томатов',
  'product.uvThread.app2': 'Огурцы',
  'product.uvThread.app2Desc': 'Поддержка плетей огурцов',
  'product.uvThread.app3': 'Бобовые',
  'product.uvThread.app3Desc': 'Подвязка фасоли и гороха',
  'product.uvThread.app4': 'Перец',
  'product.uvThread.app4Desc': 'Поддержка стеблей перца',
  'product.uvThread.app5': 'Лекарственные растения',
  'product.uvThread.app5Desc': 'Подвязка высокорослых лекарственных растений',
  'product.uvThread.installationGuide': 'Руководство по установке',
  'product.uvThread.step1': 'Шаг 1: Подготовка',
  'product.uvThread.step1Desc': 'Подготовьте необходимые инструменты и определите точки крепления',
  'product.uvThread.step2': 'Шаг 2: Крепление верхней части',
  'product.uvThread.step2Desc': 'Закрепите нить на верхней конструкции теплицы',
  'product.uvThread.step3': 'Шаг 3: Подвязка растения',
  'product.uvThread.step3Desc': 'Аккуратно обвяжите стебель растения, не затягивая слишком туго',
  'product.uvThread.step4': 'Шаг 4: Регулировка',
  'product.uvThread.step4Desc': 'При необходимости отрегулируйте натяжение нити',
  'product.uvThread.step5': 'Шаг 5: Контроль',
  'product.uvThread.step5Desc': 'Регулярно проверяйте состояние подвязки и при необходимости корректируйте',
  'product.uvThread.maintenance': 'Обслуживание',
  'product.uvThread.maintenance1': 'Очистка',
  'product.uvThread.maintenance1Desc': 'Регулярно очищайте нить от пыли и загрязнений',
  'product.uvThread.maintenance2': 'Проверка',
  'product.uvThread.maintenance2Desc': 'Периодически проверяйте целостность нити',
  'product.uvThread.maintenance3': 'Замена',
  'product.uvThread.maintenance3Desc': 'Заменяйте поврежденные участки нити',
  'product.uvThread.maintenance4': 'Хранение',
  'product.uvThread.maintenance4Desc': 'Храните неиспользованную нить в сухом месте',
  'product.uvThread.relatedProducts': 'Сопутствующие товары',
  'product.uvThread.clips': 'Клипсы для подвязки',
  'product.uvThread.clipsDesc': 'Специальные клипсы для быстрой подвязки растений',
  'product.uvThread.hooks': 'Крючки для теплиц',
  'product.uvThread.hooksDesc': 'Крючки для крепления нити к конструкции теплицы',
  'product.uvThread.tensioners': 'Натяжители нити',
  'product.uvThread.tensionersDesc': 'Устройства для регулировки натяжения нити',
  'product.uvThread.contactForOrder': 'Для заказа свяжитесь с нами',
  'product.uvThread.contactPhone': 'Телефон: +98 21 1234 5678',
  'product.uvThread.contactEmail': 'Email: info@irangh.com',
  
  // About page
  'about.title': 'О Iran GH',
  'about.subtitle': 'Ведущий поставщик решений для умных теплиц в Иране',
  'about.story': 'Наша история',
  'about.mission': 'Наша миссия',
  'about.vision': 'Наше видение',
  'about.values': 'Наши ценности',
  'about.team': 'Наша команда',
  'about.achievements': 'Достижения',
  'about.storyText1': 'Основанная в 2009 году, Iran GH находилась в авангарде тепличных технологий в Иране и регионе Ближнего Востока. То, что начиналось как небольшая инженерная фирма, выросло в ведущего поставщика решений для умных теплиц.',
  'about.storyText2': 'Наше путешествие началось с простой миссии: революционизировать сельское хозяйство через инновационные тепличные технологии. За годы мы успешно завершили более 200 проектов, от небольших семейных фермеров до крупных коммерческих операций.',
  'about.storyText3': 'Сегодня мы продолжаем расширять границы возможного в сельском хозяйстве контролируемой среды, помогая фермерам достигать более высоких урожаев при использовании меньших ресурсов.',
  'about.missionText': 'Наша миссия - предоставлять устойчивые и инновационные решения для повышения сельскохозяйственной продуктивности при сохранении природных ресурсов.',
  'about.visionText': 'Наше видение - стать региональным лидером в технологии умных теплиц и способствовать продовольственной безопасности.',
  'about.valuesText': 'Наши ценности включают инновации, качество, устойчивость и приверженность удовлетворению клиентов.',
  
  // About page hero section
  'about.hero.badge': 'Лидер в тепличной индустрии',
  'about.hero.title': 'Ария Грин Хаус',
  'about.hero.subtitle': 'Ведущий поставщик решений для умных теплиц в Иране',
  'about.hero.description': 'Имея более 15 лет опыта в проектировании, строительстве и оснащении современных теплиц, мы помогаем фермерам достигать более высокой продуктивности, используя передовые технологии.',
  'about.hero.features.experience': '15 лет опыта',
  'about.hero.features.experience_desc': 'В проектировании и строительстве современных теплиц',
  'about.hero.features.international': 'Международное сотрудничество',
  'about.hero.features.international_desc': 'С самыми авторитетными мировыми компаниями',
  'about.hero.cta.contact': 'Связаться с нами',
  'about.hero.cta.projects': 'Посмотреть проекты',
  'about.hero.achievement.title': 'Лучшая тепличная компания в Иране',
  'about.hero.achievement.description': 'Обладатель множественных наград в сельскохозяйственной индустрии',
  
  // About page stats
  'about.stats.experience': 'лет опыта',
  'about.stats.projects': 'успешных проектов',
  'about.stats.area': 'кв.м теплиц',
  'about.stats.customers': 'довольных клиентов',
  
  // About page story section
  'about.story.title': 'Наша история',
  'about.story.subtitle': 'Путешествие от идеи к прогрессу',
  'about.story.paragraph1': 'Ария Грин Хаус была основана в 2009 году с целью революционизировать сельскохозяйственную индустрию Ирана. То, что начиналось как небольшая инженерная компания, сегодня стало одной из ведущих тепличных компаний страны.',
  'about.story.paragraph2': 'Объединив местные технические знания с передовыми международными технологиями, мы смогли успешно завершить более 50 крупных проектов. От небольших семейных теплиц до больших коммерческих комплексов - все находится в области нашей экспертизы.',
  'about.story.paragraph3': 'Сегодня мы продолжаем идти по пути инноваций и непрерывного улучшения, и наша цель - помочь развитию устойчивого и современного сельского хозяйства в Иране и регионе.',
  'about.story.image_alt': 'История компании Ария Грин Хаус',
  
  // About page mission, vision, values
  'about.mission.title': 'Наша миссия',
  'about.mission.description': 'Предоставление инновационных и устойчивых решений для повышения сельскохозяйственной продуктивности и сохранения природных ресурсов через проектирование и строительство умных теплиц с международными стандартами.',
  'about.vision.title': 'Наше видение',
  'about.vision.description': 'Стать ведущей и наиболее авторитетной тепличной компанией в регионе Ближнего Востока и помочь обеспечить продовольственную безопасность через развитие современного и устойчивого сельского хозяйства.',
  'about.values.title': 'Наши ценности',
  'about.values.description': 'Инновации, качество, устойчивость, честность, приверженность клиентам и социальная ответственность являются основными принципами нашей деятельности во всех проектах и услугах.',
  'about.values.section_title': 'Наши основные ценности',
  'about.values.section_description': 'Принципы, которые направляют всю нашу деятельность',
  'about.values.innovation.title': 'Инновации',
  'about.values.innovation.description': 'Постоянный поиск новых и лучших решений для сельскохозяйственных вызовов',
  'about.values.quality.title': 'Качество',
  'about.values.quality.description': 'Использование лучших материалов и оборудования с международными стандартами',
  'about.values.service.title': 'Превосходный сервис',
  'about.values.service.description': 'Предоставление комплексных услуг от проектирования до послепродажной поддержки',
  'about.values.sustainability.title': 'Устойчивость',
  'about.values.sustainability.description': 'Приверженность защите окружающей среды и оптимальному использованию природных ресурсов',
  
  // About page team section
  'about.team.title': 'Наша экспертная команда',
  'about.team.description': 'Состоящая из лучших инженеров и специалистов тепличной индустрии',
  'about.team.ceo.name': 'Инженер Ахмад Резаи',
  'about.team.ceo.position': 'Генеральный директор и основатель',
  'about.team.ceo.description': 'С более чем 20-летним опытом в сельскохозяйственной индустрии и управлении крупными тепличными проектами',
  'about.team.engineer.name': 'Инженер Фатеме Ахмади',
  'about.team.engineer.position': 'Технический директор и дизайнер',
  'about.team.engineer.description': 'Специалист по проектированию умных теплиц и систем климат-контроля',
  'about.team.consultant.name': 'Доктор Али Мохаммади',
  'about.team.consultant.position': 'Старший сельскохозяйственный консультант',
  'about.team.consultant.description': 'Доктор сельскохозяйственных наук и специалист по гидропонным системам и беспочвенному выращиванию',
  
  // About page CTA section
  'about.cta.title': 'Готовы работать с нами?',
  'about.cta.description': 'Давайте обсудим, как мы можем помочь вам достичь ваших тепличных целей',
  'about.cta.contact': 'Связаться с нами',
  'about.cta.services': 'Посмотреть услуги'
};

export default ruCommon;
